export default __webpack_public_path__ + "static/media/XamôdæsColor1000.a537444a.png";